import * as Api from '@Api/index';

import type { ProductData } from '@Types/Product';

export interface GetRelatedProductsParams {
  productId: number;
  limit?: number;
}

interface RelatedProductsResponse {
  ok: boolean;
  data: {
    products: Record<string, { related: ProductData[] }>;
  };
}

let timer = null;
const productIds: number[] = [];
const resolvers: ((response: RelatedProductsResponse) => void)[] = [];

/**
 * Функция, получающая массив сопутствующих товаров для товара с заданным `productId`.
 * Запросы к API группируются и выполняются с задержкой в 300 мс.
 * @param params.productId - Идентификатор товара, для которого запрашиваем массив сопутствующих товаров.
 * @param params.limit - Максимальное количество сопутствующих товаров в массиве (по умолчанию 5).
 * @returns Промис с несколькими массивами сопутствующих товаров.
 */
async function getRelatedProducts({ productId, limit = 5 }: GetRelatedProductsParams) {
  return new Promise<RelatedProductsResponse>((resolve) => {
    productIds.push(productId);
    resolvers.push(resolve);

    if (timer) return;

    timer = setTimeout(async () => {
      const currentProductIds = productIds.slice(0);
      const currentResolvers = resolvers.slice(0);

      timer = null;
      productIds.length = 0;
      resolvers.length = 0;

      const url = `/backend/v2/products/${currentProductIds.join(',')}/related?limit=${limit}`;
      const res = await Api.queryProxi<RelatedProductsResponse>(url);

      currentResolvers.forEach((resolver) => {
        resolver(res);
      });
    }, 300);
  });
}

export default getRelatedProducts;
